
function slide2_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var banners = '';
  var cislo = 0;

  slideReset();
  changeBG("bg2");
  $('#tmi1').removeClass('active');
  $('#tmi3').removeClass('active');
  $('#tmi2').addClass('active');

  bmcont = '<div id="sl2_head"></div><div id="sl2_cnt" class="sl_cnt"></div><div id="cara1" class="cara"></div><div id="viteZe" class="viteZe" style="display:none;"><p>'+jsondata["sl2_txt1"]+'</p></div><div id="kontakt" style="display:none;">'+jsondata["sl2_tlac2"]+'</div><div id="mapaCR" class="menu_bott_small" style="display:none;">'+jsondata["sl2_tlac1"]+'</div><div id="sl2_bm1" class="menu_bott_big">';
  pocet = jsondata["sl2_menu1"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id="sl1_big'+i+'" class="bmi_big" data-clicked="'+i+'"><div class="bmi_bg_big"></div><div class="bmi_point_big">';
    if (i == 1) {
      bmcont += '<i class="icon icon-3"></i>';
    } else {
      cislo = cislo + 1;
      bmcont += '<i class="number">'+cislo+'</i>';
    }
    bmcont += '</div><div id="big'+i+'_tt" class="bmitt_big">'+jsondata["sl2_menu1"][i-1]+'</div></div>';
  }
  bmcont += '</div>';
  bmcont += '<div id="page1" class="arrowL"><i class="arrow-left"></i></div><div id="page3" class="arrowR"><i class="arrow-right"></i></div>';

  $("#slide2").html(bmcont);

  $('#slide2').fadeIn(1000);
  $('#viteZe').fadeIn(500);
  $('#kontakt').fadeIn(200);
  $('#mapaCR').fadeIn(100);
  bannerReset();
  loadBanners(3,"sl2_banner1");

  $("#circle_pos_2_1").on("click", function(){
		/*var id = $(this).attr("id");
    var clickid = $(this).data("clicked");*/
    clickBanner("circle_pos_2_1",3);

      $(".bmi_small .bmi_bg_small").fadeOut(300);
      $(".bmi_small .bmi_point_small").hide();
      $(".bmi_small .bmi_bg_small_active").fadeIn(300);

      $("#ban_3_1").fadeIn(100);
      bannerReset();
  		var bannerBox = document.getElementById("ban_3_1");
  		TweenMax.to(bannerBox, 1, {x:0, y:-410,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });

  $("#circle_pos_2_2").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");
    console.log(id);
    console.log(clickid);
    clickBanner("circle_pos_2_2",3);

      //$(".menu_bott_small").fadeOut();
      /*$(".bmi_small .bmi_bg_small").show();
      $(".bmi_small .bmi_point_small").removeClass("active");*/

      $("#"+id+" .circle_bg").hide();
      $("#"+id+" .circle_anim").hide();
      $("#circle_2").addClass("active");
      $("#circle_2 .icon-"+clickid).addClass("active");

      $("#ban_3_2").fadeIn(100);
      bannerReset();
  		var bannerBox = document.getElementById("ban_3_2");
  		TweenMax.to(bannerBox, 1, {x:0, y:-400,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });
/*
  $(".bmi_small").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");
    console.log(clickid);
    console.log(id);

    $(".bmi_small .bmi_bg_small").show();
    $(".bmi_small .bmi_point_small").removeClass("active");

    bannerReset();
    clickBanner(id,clickid);

    $("#"+id+" .bmi_bg_small").hide();
    $("#"+id+" .bmi_point_small").addClass("active");
    bannerReset();
    $("#ban_2_"+clickid).fadeIn(100);
    var bannerBox = document.getElementById("ban_2_"+clickid);
    TweenMax.to(bannerBox, 1, {x:0, y:-470,  ease:Quint.easeOut});
    TweenMax.to(bannerBox, 0.5, {autoAlpha:1});

  });*/

  $("#page1").on("click", function(){
    bannerReset();
    slide1_anima();
  });

  $("#page3").on("click", function(){
    bannerReset();
    slide3_anima();
  });




}
